import React, { memo } from 'react';
import { StarIcon } from 'lucide-react';
function Stars() {
  return <div className="flex gap-1 mb-3" data-id="element-336">
      <StarIcon className="w-5 h-5 text-gold-500 fill-gold-500" data-id="element-337" />
      <StarIcon className="w-5 h-5 text-gold-500 fill-gold-500" data-id="element-338" />
      <StarIcon className="w-5 h-5 text-gold-500 fill-gold-500" data-id="element-339" />
      <StarIcon className="w-5 h-5 text-gold-500 fill-gold-500" data-id="element-340" />
      <StarIcon className="w-5 h-5 text-gold-500 fill-gold-500" data-id="element-341" />
    </div>;
}
export function TestimonialsSection() {
  return <section className="w-full bg-white py-16 md:py-20 px-4" data-id="element-342">
      <div className="max-w-4xl mx-auto" data-id="element-343">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-gray-900 text-center mb-4" data-id="element-344">
          💬 Lo que dicen nuestras alumnas
        </h2>
        <p className="font-body text-gray-600 text-center mb-12" data-id="element-345">
          Personas reales que transformaron su relación con el Tarot
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-346">
          {/* Testimonial 1 */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 shadow-sm" data-id="element-347">
            <Stars data-id="element-348" />
            <p className="font-body text-gray-700 italic mb-4 leading-relaxed" data-id="element-349">
              "Siempre quise aprender Tarot pero todo lo que encontraba era
              confuso y contradictorio. Este ebook me explicó todo paso a paso,
              como si alguien me estuviera guiando de la mano. Hoy hago mis
              propias tiradas y me siento súper conectada con las cartas."
            </p>
            <div className="flex items-center gap-3" data-id="element-350">
              <div className="w-10 h-10 bg-gold-500 rounded-full flex items-center justify-center font-heading font-bold text-white" data-id="element-351">
                C
              </div>
              <div data-id="element-352">
                <p className="font-body font-semibold text-gray-900 text-sm" data-id="element-353">
                  Camila R., 28 años
                </p>
                <p className="font-body text-gray-500 text-xs" data-id="element-354">Buenos Aires</p>
              </div>
            </div>
          </div>

          {/* Testimonial 2 */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 shadow-sm" data-id="element-355">
            <Stars data-id="element-356" />
            <p className="font-body text-gray-700 italic mb-4 leading-relaxed" data-id="element-357">
              "Probé varios cursos online y videos de YouTube, pero nada me daba
              una estructura clara. Este curso es diferente: vas de lo básico a
              lo avanzado sin perderte. Por fin entiendo el significado de cada
              carta sin tener que memorizar todo."
            </p>
            <div className="flex items-center gap-3" data-id="element-358">
              <div className="w-10 h-10 bg-gold-500 rounded-full flex items-center justify-center font-heading font-bold text-white" data-id="element-359">
                V
              </div>
              <div data-id="element-360">
                <p className="font-body font-semibold text-gray-900 text-sm" data-id="element-361">
                  Valentina M., 34 años
                </p>
                <p className="font-body text-gray-500 text-xs" data-id="element-362">Córdoba</p>
              </div>
            </div>
          </div>

          {/* Testimonial 3 */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 shadow-sm" data-id="element-363">
            <Stars data-id="element-364" />
            <p className="font-body text-gray-700 italic mb-4 leading-relaxed" data-id="element-365">
              "El Tarot se convirtió en mi herramienta de reflexión diaria. Cada
              mañana saco una carta y me ayuda a entender lo que estoy viviendo.
              Este curso me enseñó a usarlo como un espejo de autoconocimiento,
              no como algo místico o inalcanzable."
            </p>
            <div className="flex items-center gap-3" data-id="element-366">
              <div className="w-10 h-10 bg-gold-500 rounded-full flex items-center justify-center font-heading font-bold text-white" data-id="element-367">
                L
              </div>
              <div data-id="element-368">
                <p className="font-body font-semibold text-gray-900 text-sm" data-id="element-369">
                  Luciana G., 41 años
                </p>
                <p className="font-body text-gray-500 text-xs" data-id="element-370">Mendoza</p>
              </div>
            </div>
          </div>

          {/* Testimonial 4 */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 shadow-sm" data-id="element-371">
            <Stars data-id="element-372" />
            <p className="font-body text-gray-700 italic mb-4 leading-relaxed" data-id="element-373">
              "Lo que más me gustó fueron los ejercicios prácticos. No es solo
              leer teoría: te ponen a practicar desde el primer día. El diario
              de 30 días fue un antes y un después para mí. Súper recomendado
              para cualquiera que quiera empezar."
            </p>
            <div className="flex items-center gap-3" data-id="element-374">
              <div className="w-10 h-10 bg-gold-500 rounded-full flex items-center justify-center font-heading font-bold text-white" data-id="element-375">
                S
              </div>
              <div data-id="element-376">
                <p className="font-body font-semibold text-gray-900 text-sm" data-id="element-377">
                  Sofía P., 26 años
                </p>
                <p className="font-body text-gray-500 text-xs" data-id="element-378">Rosario</p>
              </div>
            </div>
          </div>

          {/* Testimonial 5 - Full width */}
          <div className="bg-gray-50 rounded-xl p-6 border border-gray-100 shadow-sm md:col-span-2" data-id="element-379">
            <Stars data-id="element-380" />
            <p className="font-body text-gray-700 italic mb-4 leading-relaxed" data-id="element-381">
              "Los bonos valen oro. La guía de limpieza energética me ayudó a
              crear un espacio sagrado para mis lecturas, y el mazo imprimible
              fue un regalo increíble. Sentí que estaba recibiendo mucho más de
              lo que pagué. Es una inversión que cambió mi forma de conectar
              conmigo misma."
            </p>
            <div className="flex items-center gap-3" data-id="element-382">
              <div className="w-10 h-10 bg-gold-500 rounded-full flex items-center justify-center font-heading font-bold text-white" data-id="element-383">
                M
              </div>
              <div data-id="element-384">
                <p className="font-body font-semibold text-gray-900 text-sm" data-id="element-385">
                  Mariana D., 38 años
                </p>
                <p className="font-body text-gray-500 text-xs" data-id="element-386">Tucumán</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}